import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import { Link } from 'react-router-dom';
// material
import { Card, Button, Typography, Grid, CardHeader, Box, CardActionArea } from '@mui/material';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import EditIcon from "../../../assets/icons/icon_edit.svg";
import ChartIcon from '../../chartIcon'
import ViewIcon from '../../../assets/icons/icon_view.svg';
import { makeStyles } from '@mui/styles'
import { DecryptData } from '../../../utils/encryptDecrypt';

// ----------------------------------------------------------------------
DashboardCard.propTypes = {
  dashboard: PropTypes.object
};

const useStyles = makeStyles((theme) => ({
  actionArea: {
    "&:hover $focusHighlight": {
      opacity: 0
    }
  },
  focusHighlight: {},
  btnIcon: {
    boxShadow: 'none',
    backgroundColor: 'transparent',
    borderRadius: 0,
    "&:focus, &.Mui-focusVisible, &:active": {
      boxShadow: 'none',
      backgroundColor: 'transparent',
      borderRadius: 0,
    },
  }
}));


export default function DashboardCard({ dashboard, handleEditDashboard }) {
  let role = DecryptData(localStorage.getItem('role'))
  let { dashboardDescription, dashboardName, updatedAt, _id, sheets } = dashboard;
  const classes = useStyles();

  const calAllReportsInDash = (sheets) => {
    let totalRepoorts = 0
    sheets?.map(sheet => {
      totalRepoorts = totalRepoorts + sheet?.reports?.length
    })
    return totalRepoorts
  }

  let NoOfReports = calAllReportsInDash(sheets)



  return (
    <Card className='dash_card'>
      <CardHeader className="dashboard-card-header"
        title={<Button variant="text" className="blk_icon card-main-title" onClick={() => window.open(`/embedDashboard/${_id}`, "_self")}
        >
          <h3> {dashboardName} </h3>
        </Button>}
        subheader={
          <span>
            <p className='dash_card_subhead'> {dashboardDescription}</p>
            <span className='dash_card_sub_color'> {`${NoOfReports} Report${NoOfReports > 1 ? 's' : ''} | Edited: ${moment(updatedAt).fromNow()}`}</span>
          </span>
        }
      />

      <CardActionArea className="report-card-action" onClick={() => window.open(`/embedDashboard/${_id}`, "_self")}
        //component={Link} to={'/reportGraph/' + report._id}
        classes={{
          root: classes.actionArea,
          focusHighlight: classes.focusHighlight
        }}>
        <CardContent className='cm-card-content dashboard-card-content'>
          <CardMedia
            component="img"
            className="dashboard-card-img"
            src={ChartIcon({ chartType: sheets?.[0]?.reports?.[0]?.reportId?.chartType ?? 'bar' })}
            title={dashboardName}
          />
        </CardContent>
      </CardActionArea>

      <CardContent className='cm-card-content card-footer'>

        <Grid container direction="row" alignItems="center">

          {role && (role.toLowerCase() === 'superadmin' || role === dashboard?.createdByDetails?.s_uuid || role === dashboard?.createdByDetails?.email) &&
            <Grid item className="icon-container" style={{ marginRignt: '4% !important' }}>
              <Link className="blk_icon" to={""} onClick={() => handleEditDashboard(dashboard)} >
                <Box display='flex' alignItems='center' spacing={2} className="icon-container">
                  <img src={EditIcon} />
                  <Typography ml={1}>Edit</Typography>
                </Box>
              </Link>
            </Grid>
          }
          <Grid item className="icon-container">
            <Link className="blk_icon" to={"/embedDashboard/" + _id}>
              <Box display='flex' alignItems='center' spacing={2} className="icon-container">
                <img src={ViewIcon} />
                <Typography ml={1}>Preview</Typography>
              </Box>
            </Link>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
